<template>
    <div class="brand-page">
        <div class="row no-gutters brands-hero" id="Brands">
            <h1
                class="ml-3 text-light"
                style="position: absolute; bottom: 2rem; left: 2rem;"
            >
                Brands
            </h1>
        </div>

        <div class="blackspace">
            <p>
                <span>Brands matter.</span>In today's competitive and interconnected world, brands have become more than just a name or a logo. They represent a promise, a reputation, and a 
                set of values that consumers connect with on an emotional level.
            </p>
        </div>

        <div class="all-brands-container">
            
            <router-link :to="{ name: 'boss' }" id="boss">
                    <div>
                        <img src="/images/logos/Boss-logo-white.svg" alt="Boss logo">
                    </div>
            </router-link>
            <router-link :to="{ name: 'prosafety' }" id="prosafety">
                <div>
                    <img src="/images/logos/PIP-logo-white.svg" alt="pip pro safety logo">
                </div>
            </router-link>
            <router-link :to="{ name: 'mud' }" id="mud">
                <div>
                    <img src="/images/logos/Mud-logo-white.svg" alt="mud logo">
                </div>
            </router-link>

            <router-link :to="{ name: 'safetyworks' }" id="safetyworks">
                <div>
                    <img src="/images/logos/SafetyWorks-logo-white.svg" alt="Safety works logo">
                </div>
            </router-link>
            <router-link :to="{ name: 'hearos' }" id="hearos">
                <div>
                    <img src="/images/logos/Hearos-logo-white.svg" alt="Hearos logo">
                </div>
            </router-link>
            <router-link :to="{ name: 'westcountygardener' }" id="Westcountygardener">
                <div>
                    <img src="/images/logos/WestCounty-logo-white.svg" alt="WestCounty logo">
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {};
    },
    methods: {
        getLogo() {
            return "/images/pip-logo-white.svg";
        }
    }
};
</script>

